import { Input } from "@/components/ui/input";
import { Field } from "@/components/common";

const TEXT = {
  party: { title: "Opening Balance (ओपनिंग बैलेंस)", receive: ["To Receive / Debit (+)", "पार्टी से पैसा लेना बाकी है"], pay: ["To Pay / Credit (−)", "पार्टी को एडवांस दिया हुआ है"], order: ["receive", "pay"] },
  vendor: { title: "Opening Balance (ओपनिंग बैलेंस)", pay: ["To Pay / Credit (−)", "पुराना बकाया देना बाकी है"], receive: ["To Receive / Debit (+)", "एडवांस रिकवर करना है"], order: ["pay", "receive"] },
};

export function OpeningFields({ f, setF, kind = "party", className = "" }) {
  const t = TEXT[kind];
  const type = f.opening_type || t.order[0];
  return (
    <div className={`rounded-xl border p-3 ${className}`} data-testid="opening-section">
      <div className="label-xs mb-2">{t.title}</div>
      <div className="grid gap-3 sm:grid-cols-3">
        <Field label="Opening Balance (₹)"><Input type="number" min="0" step="0.01" data-testid="opening-amount-input" value={f.opening_balance ?? ""} onChange={(e) => setF({ ...f, opening_balance: e.target.value })} placeholder="0" /></Field>
        <Field label="Balance Type">
          <div className="flex gap-1.5" data-testid="opening-type-toggle">
            {t.order.map((k) => (
              <button type="button" key={k} data-testid={`opening-type-${k}`} onClick={() => setF({ ...f, opening_type: k })}
                className={`flex-1 rounded-md border px-2 py-1.5 text-left text-[11px] leading-tight transition-colors ${type === k ? (k === "receive" ? "border-emerald-600 bg-emerald-50 text-emerald-800 dark:bg-emerald-950 dark:text-emerald-200" : "border-rose-600 bg-rose-50 text-rose-800 dark:bg-rose-950 dark:text-rose-200") : "hover:bg-accent"}`}>
                <div className="font-semibold">{t[k][0]}</div><div className="opacity-80">{t[k][1]}</div>
              </button>
            ))}
          </div>
        </Field>
        <Field label="Effective Date"><Input type="date" data-testid="opening-date-input" value={f.opening_date || ""} onChange={(e) => setF({ ...f, opening_date: e.target.value })} /></Field>
      </div>
    </div>
  );
}

export const openingBody = (f, def) => ({ opening_balance: Number(f.opening_balance) || 0, opening_type: f.opening_type || def, opening_date: f.opening_date || "" });
